"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawaySchedulerConfigToJSON = exports.GiveawaySchedulerConfigFromJSONTyped = exports.GiveawaySchedulerConfigFromJSON = exports.instanceOfGiveawaySchedulerConfig = void 0;
var GiveawaySchedulerConfigStatus_1 = require("./GiveawaySchedulerConfigStatus");
/**
 * Check if a given object implements the GiveawaySchedulerConfig interface.
 */
function instanceOfGiveawaySchedulerConfig(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "repeatTimes" in value;
    isInstance = isInstance && "durationTime" in value;
    isInstance = isInstance && "ownerId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "cycle" in value;
    return isInstance;
}
exports.instanceOfGiveawaySchedulerConfig = instanceOfGiveawaySchedulerConfig;
function GiveawaySchedulerConfigFromJSON(json) {
    return GiveawaySchedulerConfigFromJSONTyped(json, false);
}
exports.GiveawaySchedulerConfigFromJSON = GiveawaySchedulerConfigFromJSON;
function GiveawaySchedulerConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'repeatTimes': json['repeatTimes'],
        'durationTime': json['durationTime'],
        'ownerId': json['ownerId'],
        'status': (0, GiveawaySchedulerConfigStatus_1.GiveawaySchedulerConfigStatusFromJSON)(json['status']),
        'cycle': json['cycle'],
    };
}
exports.GiveawaySchedulerConfigFromJSONTyped = GiveawaySchedulerConfigFromJSONTyped;
function GiveawaySchedulerConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'repeatTimes': value.repeatTimes,
        'durationTime': value.durationTime,
        'ownerId': value.ownerId,
        'status': (0, GiveawaySchedulerConfigStatus_1.GiveawaySchedulerConfigStatusToJSON)(value.status),
        'cycle': value.cycle,
    };
}
exports.GiveawaySchedulerConfigToJSON = GiveawaySchedulerConfigToJSON;
